export default __webpack_public_path__ + "static/media/info_bg_banner.3c677253.png";